/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1ClassroomdisciplineIdLangs202,
  PutApiV1ClassroomdisciplineIdLangs400,
  PutApiV1ClassroomdisciplineIdLangs401,
  PutApiV1ClassroomdisciplineIdLangs404,
  PutApiV1ClassroomdisciplineIdLangsMutationRequest,
  PutApiV1ClassroomdisciplineIdLangsMutationResponse,
  PutApiV1ClassroomdisciplineIdLangsPathParams,
} from "../../types/classPlanningLangController/PutApiV1ClassroomdisciplineIdLangs.ts";
import { classroomDisciplineLangBatchViewModelSchema } from "../classroomDisciplineLangBatchViewModelSchema.ts";

export const putApiV1ClassroomdisciplineIdLangsPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1ClassroomdisciplineIdLangsPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1ClassroomdisciplineIdLangs202Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdLangs202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1ClassroomdisciplineIdLangs400Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdLangs400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1ClassroomdisciplineIdLangs401Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdLangs401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1ClassroomdisciplineIdLangs404Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdLangs404>;

export const putApiV1ClassroomdisciplineIdLangsMutationRequestSchema = z.lazy(
  () => classroomDisciplineLangBatchViewModelSchema,
) as unknown as ToZod<PutApiV1ClassroomdisciplineIdLangsMutationRequest>;

export const putApiV1ClassroomdisciplineIdLangsMutationResponseSchema = z.lazy(
  () => putApiV1ClassroomdisciplineIdLangs202Schema,
) as unknown as ToZod<PutApiV1ClassroomdisciplineIdLangsMutationResponse>;
